<template>
  <div v-if="!showOld" class="login">
    <div class="left">
      <el-image :src="JPUTLogIn" :style="{ width: '100%', height: '100%', overflow: 'hidden' }" />
    </div>
    <div class="right">
      <div class="flex w-full justify-end p-4 items-center" @click="verifyDocument">
        <p class="text-sm">Verify Document</p>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="w-6 h-6" color="#606266" style="transform: rotate(-180deg);">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
        </svg>
      </div>
      <div class="center">
        <div>
          <div class="logo">
            <!-- <el-image :src="JPUTLogoHorizontalBlack" class="text-center" /> -->
          </div>
          <div style="padding-top: 20px;" v-loading="loading">
            <div class="login-tabs">
              <div :class="itemClass1" @click="() => loginTab = 1">Customer and Terminal Staff Login</div>
              <div :class="itemClass2" @click="() => { loginTab = 2; showQR = false }">Barge and Operator Login (MVP)
              </div>
            </div>
            <div style="padding-top: 20px;">
              <loginCustomerAndJPUTStaff v-if="showCustomerAndJPUtStaffLogin" @load="(val) => loading = val">
              </loginCustomerAndJPUTStaff>
              <loginBargeAndOperator v-if="showBargeAndOperatorLogin" @load="(val) => loading = val"
                @qr="showQR = true"></loginBargeAndOperator>
              <loginQRCode v-if="showLoginQRCode" @passwordLogin="showQR = false"></loginQRCode>
            </div>
          </div>
        </div>
      </div>
      <div class="announcementBanner">
        <p class="m-4">
          By accessing this website, you are deemed to have proper notice of and agree to be bound by the provisions set
          out in the <a style="color:blue; text-decoration: underline;" href="">JP-Online Terms of Use</a> and the <a
            style="color:blue; text-decoration: underline;" href="">General Rules and Regulations of Jurong Port</a> and
          the <a style="color:blue; text-decoration: underline;" href="">Terms for Inter-Gateway Haulage (IGH)
            Scheme</a> which may be amended from time to time.
        </p>
      </div>

    </div>
  </div>
  <div v-else>
    <loginOld></loginOld>
  </div>
</template>
<script>
import { removeToken, removeMvpToken } from "@/utils/auth";
import JPUTLogIn from "@/assets/JPUTLogIn.jpg";
import JPUTLogoHorizontalBlack from "@/assets/JPUTLogoHorizontalBlack.png";
import loginCustomerAndJPUTStaff from "./loginCustomerAndJPUTStaff.vue";
import loginBargeAndOperator from "./loginBargeAndOperator.vue";
import loginQRCode from "./loginQRCode.vue";
import loginOld from "./loginOld.vue";
import Announcement from "./announcement.vue";

export default {
  name: 'Login',
  components: {
    loginCustomerAndJPUTStaff,
    loginBargeAndOperator,
    loginQRCode,
    loginOld,
    Announcement,
  },
  data() {
    return {
      loading: false,
      showOld: false,
      JPUTLogIn,
      JPUTLogoHorizontalBlack,
      loginTab: 1,
      showQR: false,
      isMvp: false,
    };
  },
  created() {
    removeToken();
    removeMvpToken();
    sessionStorage.removeItem("pageStatus");
    sessionStorage.removeItem("editData");
    this.isMvp = (this.$route?.query?.isMvp ?? 'false') == 'true' ? true : false
    this.loginTab = this.isMvp ? 2 : 1
  },
  computed: {
    itemClass1() {
      return this.getItemClass(1)
    },
    itemClass2() {
      return this.getItemClass(2)
    },
    showCustomerAndJPUtStaffLogin() {
      return this.loginTab == 1
    },
    showBargeAndOperatorLogin() {
      return this.loginTab == 2 && !this.showQR
    },
    showLoginQRCode() {
      return this.loginTab == 2 && this.showQR
    },
  },
  methods: {
    getItemClass(index) {
      return this.loginTab == index ? 'item active' : 'item'
    },
    verifyDocument() {
      this.$router.push({ path: '/holdingCertificate/verification' })
    }

  }
};
</script>
<style scoped lang="scss">
.login {
  width: 100vw;
  height: 100%;
  display: flex;
  flex-direction: row;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  justify-content: center;
  align-items: center;
  background-color: white;
  overflow: hidden;
  font-size: 11px;
  font-weight: 400;
  color: #82889C;

  .center {
    margin: calc((100vh - 510px)/2) auto 0 auto;
    width: 400px;
    height: 510px;
  }

  .left {
    width: 35%;
    height: 100%;
    overflow: hidden;

    img {
      width: 100% !important;
      height: 100% !important;
    }
  }

  .right {
    width: 65%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }

  .logo {
    width: 120px;
    margin: 0px auto;
  }

  .login-tabs {
    display: flex;
    width: 100%;
    text-align: center;

    .item {
      flex: 50%;
      border-bottom: 2px solid #DADBE1;
      padding: 10px 0px;
      cursor: pointer;
    }

    .item.active {
      color: #000000;
      border-bottom: 2px solid #0FC000;
      font-weight: 500;
    }
  }
}

@media only screen and (max-width: 600px) {
  .login {
    overflow-x: hidden;
    overflow-y: auto;

    .center {
      margin: calc((100vh - 530px)/2) auto;
      width: 100%;
      height: 510px;
    }

    .left {
      display: none;
    }

    .right {
      width: 100% !important;
      padding: 10px;
    }

    .announcementBanner {
      margin-top: -50px;
      padding: 10px
    }
  }
}
</style>
